import TeamManagement from "./serviceteamManagement";
export default TeamManagement;